module.exports = __webpack_public_path__ + "static/security1@2x-505fbfb90374bc80b82b3d64d9533ff1.png";